/*
 * NotFoundPage Messages
 *
 * This contains all the text for the NotFoundPage component.
 */
import { defineMessages } from 'react-intl';

export const scope = 'boilerplate.containers.NotFoundPage';

export default defineMessages({
    header: {
        id: `${scope}.header`,
        defaultMessage: 'Page not found.'
    }
});
